(function () {
  'use strict';

  if (window.HOTHomepageRedesignLoaded) return;
  window.HOTHomepageRedesignLoaded = true;

  function money(cents) {
    if (window.theme && theme.Currency) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return '$' + (Number(cents) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function initializeEntrance(section) {
    if (!section || section.dataset.hotInitialized) return;
    section.dataset.hotInitialized = 'true';
    var checks = Array.prototype.slice.call(section.querySelectorAll('[data-hot-bundle-item]'));
    var count = section.querySelector('[data-hot-bundle-count]');
    var total = section.querySelector('[data-hot-bundle-total]');
    var button = section.querySelector('[data-hot-bundle-add]');
    var detail = section.querySelector('[data-hot-bundle-detail]');
    var error = section.querySelector('[data-hot-bundle-error]');

    function selected() { return checks.filter(function (check) { return check.checked; }); }

    function refresh() {
      var items = selected();
      var price = items.reduce(function (sum, item) { return sum + Number(item.dataset.price || 0); }, 0);
      if (count) count.textContent = String(items.length);
      if (total) total.innerHTML = money(price);
      if (button) {
        button.disabled = items.length === 0;
        button.innerHTML = items.length ? 'Add ' + items.length + ' items &nbsp; · &nbsp; ' + money(price) : 'Select an item';
      }
      if (detail && items[0]) { detail.href = items[0].dataset.productUrl;
        var detailName = detail.querySelector('[data-hot-bundle-detail-name]');
        if (detailName && items[0].dataset.productTitle) detailName.textContent = ' for ' + items[0].dataset.productTitle;
    }
    }

    checks.forEach(function (check) { check.addEventListener('change', refresh); });
    refresh();

    if (!button) return;
    button.addEventListener('click', function () {
      var items = selected();
      if (!items.length || button.disabled) return;
      error.hidden = true;
      button.disabled = true;
      button.textContent = 'Adding to your bag…';

      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items.map(function (item) { return { id: Number(item.value), quantity: 1 }; }) })
      }).then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error(payload.description || 'We couldn’t add these pieces to your bag.');
          return payload;
        });
      }).then(function (payload) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: payload, addToCartBtn: button } }));
      }).catch(function (problem) {
        error.textContent = problem.message || 'We couldn’t add these pieces to your bag.';
        error.hidden = false;
      }).finally(function () {
        button.disabled = false;
        refresh();
      });
    });
  }

  function initializeSocial(section) {
    if (!section || section.dataset.hotSocialInitialized) return;
    section.dataset.hotSocialInitialized = 'true';
    var endpoint = section.dataset.feedUrl;
    if (!endpoint) return;

    fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        var contentType = response.headers.get('content-type') || '';
        if (!response.ok || contentType.indexOf('application/json') === -1) throw new Error('Feed unavailable');
        return response.json();
      }).then(function (payload) {
        var posts = Array.isArray(payload) ? payload : (payload.posts || payload.data || []);
        posts = posts.filter(function (post) {
          return post && post.permalink && (post.thumbnail_url || post.media_url);
        }).slice(0, 3);
        if (posts.length !== 3) return;

        var cards = section.querySelectorAll('[data-hot-social-card]');
        posts.forEach(function (post, index) {
          var card = cards[index];
          if (!card) return;
          var links = card.querySelectorAll('a');
          links.forEach(function (link) { link.href = post.permalink; });
          var image = card.querySelector('img');
          image.src = post.thumbnail_url || post.media_url;
          image.alt = post.caption || 'Recent post from House of Turnberry on Instagram';
          var time = card.querySelector('time');
          if (post.timestamp) {
            var date = new Date(post.timestamp);
            time.dateTime = post.timestamp;
            time.textContent = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          } else {
            time.textContent = 'Latest';
          }
          card.querySelector('[data-hot-video]').hidden = post.media_type !== 'VIDEO';
        });
      }).catch(function () {
        // Real Shopify-hosted fallback posts stay visible until an authenticated endpoint is configured.
      });
  }

  function initialize(root) {
    (root || document).querySelectorAll('[data-hot-entrance]').forEach(initializeEntrance);
    (root || document).querySelectorAll('[data-hot-social]').forEach(initializeSocial);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
